import React from "react";
import { useDispatch, useSelector } from 'react-redux'
//import numeral from "numeral";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashCan } from '@fortawesome/free-regular-svg-icons';

import { selectUserAccessoriesDetail } from "product_tabs/tab_accessories/selectors/selectors";
import { removeAccessory } from "product_tabs/tab_accessories/accessoriesSlice";

const AccessoriesDetail = (props) => {
  const dispatch = useDispatch();

  const user_accessories = useSelector(selectUserAccessoriesDetail);
  if(!user_accessories || user_accessories.length === 0) return null;

  const onDelete = (product_id) => {
    dispatch(removeAccessory({product_id}));
  };

  return (
    <>
      {user_accessories.map((accessory, idx) => {
        const {
          product_id,
          product_title,
          quantity,
          item_total,
        } = accessory;
        return (
          <div className="cart-section cart-accessories" key={`cart-accessory-detail-${idx}`}>
            <div className="title">
              {product_title} X {quantity}
              <button type="button" onClick={() => onDelete(product_id)} className="btn btn-link float-end btn-delete">
                <FontAwesomeIcon icon={faTrashCan} />
              </button>
            </div>
            <div className="position-relative">
              <div className="price">
                ${item_total}
              </div>
            </div>
          </div>
        )
      })}
    </>
    
  )
}

export default AccessoriesDetail;